import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalPage({
  eyebrow,
  title,
  updated,
  introduction,
  sections,
  relatedLabel,
  relatedPath,
}) {
  return (
    <div className="flex-grow px-5 py-16 sm:px-6 sm:py-20 animate-fade-in">
      <article className="mx-auto w-full max-w-4xl">
        <Link
          to="/"
          className="group mb-10 inline-flex items-center gap-2 text-sm text-gray-500 transition-colors hover:text-[#ccff00]"
        >
          <span className="transition-transform group-hover:-translate-x-1">←</span>
          Back to Home
        </Link>

        <header className="relative mb-10 overflow-hidden rounded-3xl border border-white/[0.08] bg-white/[0.03] p-7 sm:p-10">
          <div className="absolute -right-16 -top-20 h-56 w-56 rounded-full bg-[#c8ff00]/10 blur-3xl" />
          <div className="relative">
            <span className="mb-4 block text-xs font-bold uppercase tracking-[0.2em] text-[#ccff00]">
              {eyebrow}
            </span>
            <h1 className="mb-4 text-4xl font-black tracking-tight text-white sm:text-6xl">
              {title}
            </h1>
            <p className="text-sm text-gray-500">Last updated: {updated}</p>
          </div>
        </header>

        <p className="mb-10 max-w-3xl text-base leading-8 text-gray-400">
          {introduction}
        </p>

        <div className="space-y-5">
          {sections.map((section) => (
            <section
              key={section.title}
              className="rounded-2xl border border-white/[0.07] bg-white/[0.025] p-6 sm:p-8"
            >
              <h2 className="mb-4 text-xl font-bold text-white">
                {section.title}
              </h2>
              {section.paragraphs.map((paragraph) => (
                <p
                  key={paragraph}
                  className="mb-4 text-sm leading-7 text-gray-400 last:mb-0 sm:text-base"
                >
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>

        <div className="mt-12 border-t border-white/10 pt-8 text-center">
          <p className="text-sm text-gray-600">
            You may also review our{' '}
            <Link
              to={relatedPath}
              className="font-semibold text-[#ccff00] hover:underline"
            >
              {relatedLabel}
            </Link>
            .
          </p>
        </div>
      </article>
    </div>
  );
}